<template>
  <div>{{ getDisplay() }}</div>
</template>

<script>
export default {
  name: 'Clock',
  props: {
    startedAt: {type: Number, required: true},
  },
  data: () => ({intervalId: null, stoppedClock: null}),
  methods: {
    stop() {
      this.stoppedClock = Date.now() - this.startedAt
    },
    resume() {
      this.stoppedClock = 0
    },
    getValue() {
      if (this.stoppedClock) return this.stoppedClock
      return Date.now() - this.startedAt;
    },
    getDisplay() {
      return this.getValue() / 1000|0
    }
  },
  mounted() {
    this.intervalId = setInterval(() => this.$forceUpdate())
  },
  unmounted() {
    clearInterval(this.intervalId)
  },
}
</script>

<style scoped>

</style>
